import StateInterface from "../state-interface";

export const bbm_push_notification_template: StateInterface["bbm_push_notification_template"] = {
	_id: "",
	key: "",
	notification_type: "",
	category: "",
	description: "",
	title: "",
	body: "",
	image: { file_id: null, mime_type: "" },
	fallbacks: [],
	channels: {
		in_app: { enabled: false },
		push: { enabled: false, title: "", body: "" },
		whatsapp: { enabled: false, template_id: null },
		email: { enabled: false, subject: "", body: "" },
		sms: { enabled: false, dlt_template_id: null },
	},
	active: false,
	created_at: "",
	updated_at: "",
	updated_by: null,
};

export default bbm_push_notification_template;
